import axios from "axios";
import Cookies from "js-cookie";

import { ROOT_API_URL } from "config";
import { removeAllCookie } from "utils/StorageVariables";
import { Error } from "Responses/Response";

import { getToken } from "utils/utility";
import { setUserId, reset } from "utils/amplitude";
import store from "Redux/store";
import { resetAllState } from "Redux/Global/action";

const onError = async (error) => {
  if (error.response) {
    if (error.response.status === 401 || error.response.status === 403) {
      try {
        // Clear development token if in development mode
        if (process.env.NODE_ENV === 'development')
          Cookies.remove('token-local');
        
        // Clear cookies
        removeAllCookie();
        
        // Reset all Redux state
        store.dispatch(resetAllState());
        
        // Clear Amplitude data
        setUserId(undefined);
        reset();
      } catch (error) {
        Error(error?.response?.data?.detail);
      }

      return Promise.reject(error);
    }
  }

  return Promise.reject(error);
};

const request = async (options, isSecure) => {
  let baseURL = ROOT_API_URL;
  const token = getToken();

  let headers = {};

  if (isSecure) {
    headers["Authorization"] = `Token ${token}`;
  }

  const client = axios.create({
    baseURL,
    headers: { ...headers }
  });

  return client(options).catch(onError);
};

export class BaseService {
  static get = (url, isSecure = true) => {
    return request(
      {
        url,
        method: "GET",
      },
      isSecure
    );
  };

  static post = (url, data, isSecure = true) => {
    return request(
      {
        url,
        method: "POST",
        data,
      },
      isSecure
    );
  };

  static put = (url, data, isSecure = true) => {
    return request(
      {
        url,
        method: "PUT",
        data,
      },
      isSecure
    );
  };
  static patch = (url, data, isSecure = true) => {
    return request(
      {
        url,
        method: "PATCH",
        data,
      },
      isSecure
    );
  };

  static remove = (url, isSecure = true) => {
    return request(
      {
        url,
        method: "DELETE",
      },
      isSecure
    );
  };
}
